import React, { FC, forwardRef } from 'react';
import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import styled from 'styled-components';

const StyledTextField = styled(MuiTextField)`
  .Mui-error {
    white-space: pre-line;
  }

  .MuiInputBase-root {
    color: var(--text-color);
    background-color: light-dark(var(--surface-ground), var(--surface-200));
  }

  .MuiInputLabel-root {
    color: var(--text-color);
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: var(--surface-border);
  }

  .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-200);
  }

  .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: var(--primary-color);
  }
`;

export const TextField: FC<TextFieldProps> = forwardRef((props, ref) => {
  return <StyledTextField {...props} ref={ref} />;
});
